/**
 * Find Slots for given name
 * @param node
 * @param slotName
 */
export function getSlotElements(node: HTMLElement, slotName = '') {
    const elements: HTMLElement[] = [];
    for (const child of node.children) {
        if ((child.hasAttribute('slot') && child.getAttribute('slot') === slotName) || (slotName === '' && !child.hasAttribute('slot'))) {
            elements.push(child as HTMLElement);
        }
    }
    return elements;
}

/**
 * Get HTML of Slot
 * @param node Element to find slots in
 * @param slotName Name of Slot
 * @param getOuterHtml true: get outer Html / false: get inner Html / null: get inner Html except for default slot
 */
export function getSlotHtml(node: HTMLElement, slotName = '', getOuterHtml: boolean | null = null): string | null {
    const elements = getSlotElements(node, slotName);
    if (elements.length === 0) {
        return null;
    }
    return elements.map(el => {
        if ((slotName === '' && getOuterHtml === null) || getOuterHtml === true) {
            return el.outerHTML;
        }
        return el.innerHTML;
    }).join('');
}
